import axios from './axiosInstance';

export const getGoogleCalendarList = async ({
  user_id
}) => {
  try{

    const start_time = new Date()
    start_time.setHours(0,0,0,0);

    const end_time = new Date()
    end_time.setHours(23,59,59,999);

    const response = await axios({
      url : `/get-healer-calendar/${user_id}`,
      method : 'GET',
      params : {
        start_time : start_time.toISOString(),
        end_time : end_time.toISOString()
      }
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}